module.exports = __webpack_public_path__ + "assets/map_find_white.4aaafc54.svg";